<ion-content>
  <div class="px-4 py-2 padding-bottom-configuration">
    <app-header-configuration
      [title]="'P0003607.installation.volet.titre' | translate"
      [description]="'P0003607.installation.volet.description' | translate"
    >
    </app-header-configuration>

    <app-label-configuration
      [title]="'P0003607.installation.volet' | translate"
      [titleListe]="'P0003607.installation.abaissementProduction' | translate"
      [value]="actionStack!.getValue('esIMethodeAsservissement')"
      [information]="EnSavoirPlusModal"
      [liste]="P0003607AsservissementVolet"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.ElectrolyseurStandard_Installation,
          'esIMethodeAsservissement',
          $event,
          null
        )
      "
    >
    </app-label-configuration>

    @if (actionStack!.getValue('esIMethodeAsservissement') === 1) {
      <app-larged-link
        [name]="'P0003607.installation.sensContact' | translate"
        [textBeforeArrow]="
          P0003607SensContactSelEnum[actionStack!.getValue('esISensContactSel')]
            .label | translate
        "
        (onPress)="openModal()"
      >
      </app-larged-link>
    }

    <app-label-description
      [description]="
        'P0003607.installation.abaissementProduction.description' | translate
      "
    ></app-label-description>
  </div>
</ion-content>

<div class="position-absolute start-0 end-0 bottom-0 bg-white px-4 py-2">
  <div class="row">
    <div class="col-6 text-start">
      <ion-button
        color="medium"
        expand="block"
        fill="outline"
        class="mb-3"
        (click)="this.prev()"
      >
        {{ 'generic.retour' | translate }}
      </ion-button>
    </div>
    <div class="col-6 text-end">
      <ion-button color="primary" expand="block" (click)="onSubmit()">
        {{ 'generic.next' | translate }}
      </ion-button>
    </div>
  </div>
</div>
